import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { API_CONSTANTS } from '../constants';
import { HttpClientService } from './http-client.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(
    private http: HttpClientService
  ) { }

  getAllRoles(query?: any) {
    return this.http.get(API_CONSTANTS.ROLES, query)
    .pipe(
      map((res: any) => {
        return res;
      })
    );
  }
}
